import styled from 'styled-components';

export const Wrapper = styled.div`
  .select-wrap {
    position: relative;
    // top: 200px;
    height: 100%;
    // perspective: 1200px;
    text-align: center;
    overflow: hidden;
    font-size: 20px;
    color: #000;
    &:before, &:after {
      position: absolute;
      z-index: 1;
      display: block;
      content: '';
      width: 100%;
      height: 50%;
    }
    &:before {
      top: 0;
      background-image: linear-gradient(to bottom,rgb(255 255 255),rgba(1,1,1,0))
    }
    &:after {
      bottom: 0;
      background-image: linear-gradient(to top,rgb(255 255 255),rgba(1,1,1,0));    
    }

    .select-options {
      position: absolute;
      top: 45%;
      left: 0;
      width: 100%;
      height: 0;
      transform-style: preserve-3d;
      margin: 0 auto;
      display: block;
      transform: translateZ(-150px) rotateX(0deg);
      -webkit-font-smoothing: subpixel-antialiased;
      color: #666;
      .select-option {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 50px;

        -webkit-font-smoothing: subpixel-antialiased;
        @for $i from 1 through 100 {
          &:nth-child(#{$i}) {
            transform: rotateX(-18deg * ($i - 1)) translateZ(150px);
          }
        }
      }
    }
    .label-text-area {
      white-space: nowrap;
      padding: 0 35px 0 75px;
    }
  }

  .highlight {
    position: absolute;
    top: 47%;
    transform: translate(0, -50%);
    width: 100%;
    background-color: white;
    border-top: 1px solid #717171;
    border-bottom: 1px solid #717171;
    font-size: 24px;
    font-weight: 600;
    overflow: hidden;
  }
  .highlight-list {
    // display: none;
    position: absolute;
    width: 100%;
  }

  /* date */
  .date-selector {
    background: white;
    position: absolute;
    left: 50%;
    top: 25%;
    transform: translate(-50%, -50%);
    perspective: 2000px;
    display: flex;
    align-items: stretch;
    justify-content: space-between;

    width: 100%;
    height: 300px;
    >div {
      flex: 1;
    }

    .select-wrap {
      font-size: 16px;
    }
    .highlight {
      font-size: 18px;
    }
  }


`;
